// components/mobile/ProductThumb.jsx
import React, { useState } from 'react';
import { resolveImageUrl } from '../../../../components/ndoe';
import { resolveImageVariant } from '../../../../components/ndoe/imageVariant';
import imageNot from '../../../../assets/profilnot.png';

// Économie de données (16/07) : ce composant est rendu à DEUX tailles selon le
// contexte — 42×42 px dans les listes (.mobile-action-thumb) et 76×76 px dans
// l'en-tête de détail (.mobile-detail-hero) — alors qu'il chargeait l'original
// ~1254 px dans les deux cas. La taille devient donc un paramètre : un dérivé
// unique conviendrait à l'une et serait flou sur l'autre.
// Repli explicite : dérivé → original → placeholder local.
export const ProductThumb = ({ domain, image, title, largeur = 42 }) => {
  const [replie, setReplie] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!image || failed) return <img className="mobile-action-thumb is-placeholder" src={imageNot} alt={title} />;
  const src = replie ? resolveImageUrl(image) : resolveImageVariant(image, largeur, 'auto');
  return (
    <img
      className="mobile-action-thumb"
      src={src}
      alt={title}
      loading="lazy"
      onError={() => (replie ? setFailed(true) : setReplie(true))}
    />
  );
};
